// extracted by mini-css-extract-plugin
export default {"products":"gw-z","card":"hw-z","oosMessaging":"iw-z"};